import { render, staticRenderFns } from "./TableControls.vue?vue&type=template&id=d3faa9dc&scoped=true&"
import script from "./TableControls.vue?vue&type=script&lang=js&"
export * from "./TableControls.vue?vue&type=script&lang=js&"
import style0 from "./TableControls.vue?vue&type=style&index=0&id=d3faa9dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3faa9dc",
  null
  
)

export default component.exports